<template>
  <div class="tab">
    <div class="top" style="text-align: left; padding-bottom: 10px; border-bottom: none;">
      <div v-if="this.deviceSettings.length > 0">
        <table class="styled-table" >
          <tr v-for="(item, index) in this.deviceSettings" :key="index">
            <td>
              {{$t(item.name)}}
            </td>
            <td v-if="item.type === 'switcher'">
              <switches v-model="item.value" theme="bootstrap" color="success"></switches>
            </td>
            <td v-else>
              not implemented yet
            </td>
          </tr>
        </table>
        <div class="text-center">
          <button @click="save(true)">
            {{ $t('Save and Close') }}
          </button>
          <button @click="save()">
            {{ $t('Save and Stay') }}
          </button>
        </div>
      </div>
      <h2 v-else-if="!deviceId" class="text-center">
        {{$t('Connect device to the patient first')}}
      </h2>
      <h2 v-if="emptyLoad" class="text-center">
        {{$t('No available settings for the patient device')}}
      </h2>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import axios from 'axios'

export default {
  components: {},
  props: [],
  name: 'DeviceSettings',
  data () {
    return {
      deviceSettings: [],
      deviceId: null,
      allowedSettings: [{ key: 'buttonToRunMedTest', type: 'switcher', name: this.$t('External bluetooth blood pressure') }],
      emptyLoad: false,
    }
  },
  computed: {
    ...mapState(['selectedPatient', 'user']),
    device() {
      return this.deviceId ? this.$store.getters.getDeviceById(this.deviceId) : {};
    },
  },
  methods: {
    loadSettings: async function () {
      this.deviceId = this.selectedPatient.devices_ids ? this.selectedPatient.devices_ids[0] : null
      this.deviceSettings = []
      if (this.deviceId) {
        console.log('Loading settings for device', this.deviceId)
        try {
          const {imei, settings} = this.device
          const {data = {}} = await axios.get(`/api/devices/by_imei/${imei}/settings`, {params: {lang: this.$i18n.locale}});
          this.deviceSettings = this.allowedSettings
            .filter(x => data[x.key] === true || data[x.key] === 'true')
            .map(x => ({...x, value: settings && settings[x.key]}))
        } catch (e) {
          console.error(e)
          this.$notify({text: this.$t('Server communication error'), type: 'error'})
        }
        this.emptyLoad = !this.deviceSettings.length;
      }
    },

    // temp solution, in the future, it will be done for each row of settings, or as batch for changed values
    async save(closeWindow = false) {
      try {
        const dataToSend = this.deviceSettings.reduce((a, x) => {
          a[x.key] = {send: true, value: x.value}
          return a;
        }, {})
        const { data } = await axios.post(`/api/devices/by_imei/${this.device.imei}/settings`, {data: dataToSend})
        if (data.state === 'ok') {
          this.$notify({text: this.$t('Device settings saved'), type: 'success'})
          if (!this.device.settings) this.device.settings = {}
          this.deviceSettings.forEach(x => {
            this.device.settings[x.key] = x.value;
          })
        } else {
          this.$notify({text: this.$t(data.error || 'Device settings not saved'), type: 'error'})
        }

        if (closeWindow) {
          this.hideModal()
        }
      } catch (err) {
        console.error(err)
        this.$notify({text: this.$t('Device settings saving error'), type: 'error'})
      }
    },

    ...mapMutations(['hideModal'])
  },
  watch: {
    selectedPatient(newVal, oldVal) { // watch it
      console.log('patient changed: ', newVal, ' | was: ', oldVal)
      this.loadSettings()
    }
  },
  mounted() {
    this.loadSettings()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeviceSettings.vue